module.exports = __webpack_public_path__ + "static/media/21ECLAC36.78c12d69.jpg";